import { render, staticRenderFns } from "./SpeedCard.vue?vue&type=template&id=0f952375&scoped=true&"
import script from "./SpeedCard.vue?vue&type=script&lang=js&"
export * from "./SpeedCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeedCard.vue?vue&type=style&index=0&id=0f952375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f952375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VIcon,VLayout})
